import { useOrderSearchForm } from '@euler/app/flows/search/context';
import { FormGroup } from '@euler/components/form';
import { Input } from '@euler/components/form/Input';
import { memo } from 'react';

export const VehicleModelField = memo(() => {
  const { form } = useOrderSearchForm();
  return (
    <FormGroup label="车型名称">
      <Input
        value={form.vehicleModel.value ?? ''}
        placeholder="按车型名称搜索"
        clearButtonMode="always"
        onChangeText={form.vehicleModel.update}
      />
    </FormGroup>
  );
});
